import React from "react";
import "./Betting_Rebate.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import Betting_Rebate_history_card from "./Betting_Rebate_history_card/Betting_Rebate_history_card";

function Betting_Rebate() {
    const navigate = useNavigate();
  return (
    <>
      <section className="Betting_Rebate">
        <Common_white_header headingText={"Betting Rebate"} />

        <div className="container">
          {/* Top Card */}
          <div className="rebate_card">
            <h4 className="card_title">Lottery-Total betting rebate</h4>

            <div className="real_time">
              <span className="dot"></span>
              Real-time count
            </div>

            <div className="amount">₹ 0.00</div>

            <div className="upgrade_box">
              Upgrade VIP level to increase rebate rate
            </div>

            <div className="rebate_row">
              <div className="rebate_col">
                <p>Rebate Rate</p>
                <h5 className="red">0.1%</h5>
              </div>
              <div className="rebate_col">
                <p>Total Rebate</p>
                <h5 className="orange">9.64</h5>
              </div>
            </div>

            <p className="auto_text">
              Automatic code washing at 01:00:00 every morning
            </p>

            <button className="rebate_btn">One-Click Rebate</button>
          </div>

          {/* History Section */}
          <div className="history_section">
            <h4 className="history_title">Rebate History</h4>

            <Betting_Rebate_history_card/>

            <div className="">
              <Button
                className="btn-register  mb-3"
                onClick={() => navigate("/betting-rebate-history")}
              >
                View all history
              </Button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Betting_Rebate;
